export enum TransactionTypes {
    CREDIT = "CREDIT",
    DEBIT = "DEBIT"
    
}


